import { buildUrl, handleResponse } from "./auth";

export const getAdminVatSettings = () =>
  fetch(buildUrl("/api/admin/settings/vat"), {
    credentials: "include",
  }).then(handleResponse);

export const updateAdminVatSettings = (payload) =>
  fetch(buildUrl("/api/admin/settings/vat"), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const getAdminSettings = () =>
  fetch(buildUrl("/api/admin/settings"), {
    credentials: "include",
  }).then(handleResponse);

export const updateAdminSettingsSection = (sectionId, payload) =>
  fetch(buildUrl(`/api/admin/settings/${sectionId}`), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

const adminSettingsApi = {
  getAdminVatSettings,
  updateAdminVatSettings,
  getAdminSettings,
  updateAdminSettingsSection,
};

export default adminSettingsApi;
